// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2Ycuf","content":"ManualTimeModal_content__2sITd"};